import Slider from './Slider';

// export types
export type { SliderProps } from './Slider';

// export components
export { Slider };
export default Slider;
